import AbstractMessageModalController from '../abstract-message-modal';

export default class SingleMessageModalAbstract extends AbstractMessageModalController {
    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);
        this.recipientModel = this.extendedInformation.recipientModel;
        this.contact = this.extendedInformation.contact;

        this.recipientInformation = this._prepareRecipientInformation();

        this.sendToOverride = '';
        this.sendToOptions = [];
        this.selectedSendToType = 'custom';

        this._prepareAvailableSendToTypes();
    }

    sendEmail() {
        if (!this.submitEnabled) {
            return;
        }
        this.submitting = true;

        return this.api.post(`messages`, this._getSendRequestData())
            .then(() => {
                this._showMessageQueuedAlert();
                this.modalInstance.close();
            })
            .catch(e => {
                this.submitting = true;
                this.alert.handle(e);
            });
    }

    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(
            () => this.sendToOverride,
            () => {
                this._checkIfSubmitEnabled();
            }
        );

        this.scope.$watch(
            () => this.selectedSendToType,
            (newVal) => {
                switch (newVal) {
                    case 'business':
                        this.sendToOverride = this.contact.business_email;
                        return;
                    case 'custom':
                        return;
                    default:
                        this.sendToOverride = this.contact.email;
                        return;
                }
            }
        );
    }

    _prepareRecipientInformation() {
        return {
            name: this.contact.full_name,
            email: this.contact.preferred_email
        }
    }

    _prepareAvailableSendToTypes() {
        this.sendToOptions = [];

        if (this.contact.email) {
            this.sendToOptions.push({
                key: 'private',
                label: this.translate.instant('messages.send_to_types.private')
            })
        }

        if (this.contact.business_email) {
            this.sendToOptions.push({
                key: 'business',
                label: this.translate.instant('messages.send_to_types.business')
            })
        }

        this.sendToOptions.push({
            key: 'custom',
            label: this.translate.instant('messages.send_to_types.custom')
        })

        let newSendToType = 'custom';
        if(this.contact.business_preferred && this.contact.business_email) {
            newSendToType = 'business'
        } else if(this.contact.email) {
            newSendToType = 'private'
        }
        this.selectedSendToType = newSendToType;
    }

    _getPreviewRecipient() {
        return this.recipientModel;
    }

    _isSubmitEnabled() {
        return super._isSubmitEnabled() && this.sendToOverride;
    }

    _getSendRequestData() {
        return {
            ...this.extendedMessageParameterModels,
            type: 'email',
            send_to_override: this.sendToOverride,
            custom_content: this.customContent,
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: '=',
                        value: this.selectedTemplateId
                    }
                ],
                count: 1
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/single-send/single-message-modal-abstract.js